import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TakataStaticWidgetComponent} from './takata-static-widget.component';
import {ExternalLinkModule} from '../../external-link/external-link.module';
import {TrackingModule} from '@ox/data';
import {TranslateModule} from '@ox/translate';
import {GeneralModalModule} from '@ox/ui';
@NgModule({
  declarations: [TakataStaticWidgetComponent],
  imports: [
    CommonModule,
    TrackingModule,
    TranslateModule,
    ExternalLinkModule,
    GeneralModalModule
    ],
  exports: [TakataStaticWidgetComponent]
})
export class TakataStaticWidgetModule {}

export const TAKATA_STATIC_WIDGET_ROUTES = [
  {
    path: '',
    component: TakataStaticWidgetComponent,
    outlet: 'webu-recalls-center-takata-static-widget'
  }
];